import { readStorageValue, removeStorageValue } from 'hooks/use-storage/use-storage.utils';
import { DecodedJWT, JWTLocalStorage } from './jwt-service.types';

export const JWT_STORAGE_KEY = 'capella:auth_t';
export const JWT_FALLBACK_VALUE = { token: '' };

export function validateBearerToken(persistedToken: unknown): persistedToken is JWTLocalStorage {
  return typeof persistedToken === 'object' && !!persistedToken && 'token' in persistedToken;
}

export function getJWT() {
  return readStorageValue<JWTLocalStorage>({
    storageKey: JWT_STORAGE_KEY,
    fallbackValue: JWT_FALLBACK_VALUE,
    validate: validateBearerToken,
  }).token;
}

export function removeJWT() {
  removeStorageValue(JWT_STORAGE_KEY);
}

export function parseJWT(): DecodedJWT | null {
  const jwt = getJWT();
  if (!jwt) {
    return null;
  }

  try {
    return JSON.parse(atob(jwt.split('.')[1]));
  } catch (error) {
    return null;
  }
}

export function isJwtHere() {
  return !!getJWT();
}
